import * as React from 'react';
import { Link } from 'react-router-dom';
import './RssFeedsCmp.css';
import { RssFeed } from '../../types';

interface RssFeedsCmpProps {
  feeds: RssFeed[];
}

export default function RssFeedsCmp(props: RssFeedsCmpProps) {
  return (
    <React.Fragment>
      <div>
        {props.feeds &&
          props.feeds.map((feed) => (
            <span key={feed.id} className="siteFeed">
              <Link to={`/feed/${feed.id}${feed.slug ? `/${feed.slug}` : ''}`}>{feed.title}</Link>
            </span>
          ))}
      </div>
    </React.Fragment>
  );
}
